import React from 'react';
import { ShieldCheckIcon, DownloadIcon, LockIcon, HeadphonesIcon, BadgeCheckIcon } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: LockIcon,
    text: 'Pagamento sicuro'
  }, {
    icon: ShieldCheckIcon,
    text: 'Garanzia'
  }, {
    icon: DownloadIcon,
    text: 'Download immediato'
  }, {
    icon: BadgeCheckIcon,
    text: 'Protezione dati'
  }, {
    icon: HeadphonesIcon,
    text: 'Supporto'
  }];
  return <div className="w-full bg-gray-100 border-y border-gray-200 py-4" data-id="element-203">
      <div className="max-w-4xl mx-auto px-4" data-id="element-204">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-205">
          {items.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-gray-600" data-id="element-206">
              <item.icon className="w-5 h-5 text-blue-600" data-id="element-207" />
              <span className="text-sm font-medium" data-id="element-208">{item.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}